import { CalendarTab } from '../phone/tabs/CalendarTab';
import { SectionFrame } from './SectionFrame';

export function CalendarSection() {
  return (
    <SectionFrame
      title="Kalender"
      description="Verbinde Google und/oder Microsoft Outlook. Wähle den primären Kalender für neue Buchungen."
    >
      <CalendarTab />
    </SectionFrame>
  );
}
